import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/* =======================
   Models
======================= */

export interface answer {
  id?: number;
  answer?: string;
  type?:string
  _deleted?: boolean;
  with_value?:string;
  start_range?:string;
  end_range?:string;
  stage_id?:number;

}

export interface question {
  id?: number;
  question?: string;
  status?: "new" | "saved" | "update";
  answers?: answer[];
  isSaving?: boolean;
}

export interface Stage {
  id: number;
  cif: number;
  name: string;
  class_type: string;
}

/* =======================
   State
======================= */

export interface StageState {
  isLoaded: boolean;
  isLoading: boolean;
  isFetching: boolean;
  

  questions: question[];

  Stages: Stage[];


}

const initialState: StageState = {
  isLoaded: false,
  isLoading: false,
  isFetching: false,
 

  questions: [],

  Stages: [],

 
};

/* =======================
   Slice
======================= */

export const StageSlice = createSlice({
  name: "stage",
  initialState,
  reducers: {

    setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoaded = payload;
    },

    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },

    setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
      state.isFetching = payload;
    },

   

    /* =======================
       Questions
    ======================= */

    setQuestions: (state, { payload }: PayloadAction<question[]>) => {
      state.questions = Array.isArray(payload) ? payload : [];
    },

    addQuestion: (state, { payload }: PayloadAction<question>) => {
      state.questions.push({
        answers: [],
        status: "new",
        ...payload,
      });
    },

    deleteQuestion: (state, { payload }: PayloadAction<number>) => {
      const index = state.questions.findIndex(q => q.id === payload);
      if (index !== -1) state.questions.splice(index, 1);
    },

    deleteQuestionByIndex: (state, { payload }: PayloadAction<number>) => {
      if (payload >= 0 && payload < state.questions.length)
        state.questions.splice(payload, 1);
    },

    editQuestion: (
      state,
      { payload }: PayloadAction<{ index: number; question: question }>
    ) => {

      const item = state.questions[payload.index];
      if (!item) return;

      state.questions[payload.index] = {
        ...item,
        ...payload.question,
        status: payload.question.status || "update",
      };
    },

    /* =======================
       Answers
    ======================= */

    addAnswer: (
      state,
      { payload }: PayloadAction<{ q_index: number; answer: answer }>
    ) => {

      const question = state.questions[payload.q_index];
      if (!question) return;

      if (!question.answers) question.answers = [];

      question.answers.push(payload.answer);
      question.status = "update";
    },

    removeAnswer: (
      state,
      { payload }: PayloadAction<{ q_index: number; a_index: number }>
    ) => {

      const question = state.questions[payload.q_index];
      if (!question || !question.answers) return;

      if (payload.a_index < 0 || payload.a_index >= question.answers.length) return;

      question.answers.splice(payload.a_index, 1);
      question.status = "update";
    },

    deleteAnswer: (
      state,
      { payload }: PayloadAction<{ q_index: number; a_index: number }>
    ) => {

      const question = state.questions[payload.q_index];
      if (!question || !question.answers) return;

      const answer = question.answers[payload.a_index];
      if (!answer) return;

      answer._deleted = true;
      question.status = "update";
    },

    editAnswer: (
      state,
      { payload }: PayloadAction<{ q_index: number; a_index: number; answer: answer }>
    ) => {

      const question = state.questions[payload.q_index];
      if (!question || !question.answers) return;

      if (payload.a_index < 0 || payload.a_index >= question.answers.length) return;

      question.answers[payload.a_index] = {
        ...question.answers[payload.a_index],
        ...payload.answer,
      };

      question.status = "update";
    },

    /* =======================
       Stages pagination
    ======================= */

    addIRSs: (state, { payload }: PayloadAction<Stage[]>) => {
      state.Stages = payload;
    },

    


    reset: (state) => {
      state.questions = [];
      
      state.Stages = [];
      state.isLoading = false;
      state.isFetching = false;
    
    },

  },
});

export default StageSlice.reducer;
